import _vars from '../_vars';
import Swiper, {
  Navigation, Pagination,
  Autoplay
} from 'swiper';


Swiper.use([Navigation, Pagination, Autoplay]);


const swiperTestimonials = new Swiper(_vars.testiSliderEl, {
  slidesPerView: 1,
  loop: false,
  pagination: {
    el: _vars.testiPag,
    type: 'bullets',
    clickable: true
  },
  autoHeight: true,
  speed: 1200,
});

const swiperClients = new Swiper(_vars.clientsSliderEl, {
  slidesPerView: 6,
  spaceBetween: 15,
  loop: true,
  speed: 2000,
  autoplay: {
    delay: 2000,
    stopOnLastSlide: false,
    disableOnInteraction: false,
  },
});
console.log(swiperClients.params);
// swiperClients.autoplay.start();
// console.log(swiperClients.autoplay.running);
// _vars.clientsSliderEl.addEventListener("mouseover", function (e) {
//   swiperClients.params.autoplay.disableOnInteraction = false;
//   swiperClients.params.autoplay.delay = 500;
//   swiperClients.autoplay.start();
// })
